import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

interface IDadosSelect {
  nameBD: string;
  descricao: string;
}

interface BasicSelectFiltroProps {
  data: IDadosSelect[];
  label: string;
  value: string;
  disabled?: boolean;
  onChange: (valor: string) => void;

  // NOVA PROP
  borderRadius?: number;
}

export const BasicSelectFiltro: React.FC<BasicSelectFiltroProps> = ({
  data,
  label,
  value,
  disabled = false,
  onChange,
  borderRadius = 2 // valor padrão
}) => {

  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>

        <Select
          size="small"
          value={value}
          label={label}
          onChange={handleChange}
          disabled={disabled}
          sx={{
            borderRadius: borderRadius,                    // <-- AQUI
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: borderRadius                  // <-- AQUI TAMBÉM
            }
          }}
        >
          {data.map((item) => (
            <MenuItem key={item.nameBD} value={item.nameBD}>
              {item.descricao}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
